import gql from 'graphql-tag'

// 查询envolop列表
export const getDocusignEnvelopes = gql`
  query($masterType: HistoryMasterType!,$masterId: Int!) {
    getDocusignEnvelopes(
      masterType: $masterType
      masterId: $masterId
    ) {
      id
      clientName
      clientEmail
      subject
      message
      signers {
        signAnchors
        dateSignAnchors
        routingOrder
        recipient {
          name
          email
        }
        signStatus
      }
      status
      sentDate
      completedDate
      documents {
        id
        name
        extension
        originUrl
        documentId
        type
        signedUrl
        templateParams {
          keyname
          value
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      createdBy {
        id,
        username
      }
      lastModifiedBy {
        id,
        username
      }
    }
  }
`

// """根据 id 查询 Docusign Envelope"""
export const getDocusignEnvelope = gql`
  query($envelopeId: Int!) {
    getDocusignEnvelope(
      envelopeId: $envelopeId,
    ) {
      id
      clientName
      clientEmail
      ccName
      ccEmail
      subject
      vergeStaff {
        id
        username
      }
      message
      signers {
        signAnchors
        dateSignAnchors
        routingOrder
        recipient {
          name
          email
        }
        signStatus
      }
      status
      sentDate
      completedDate
      documents {
        id
        name
        extension
        originUrl
        originId
        documentId
        type
        signedUrl
        templateParams {
          keyname
          value
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      account {
        id
        name
      }
    }
  }
`

// """新建 Docusign Envelope"""
export const newDocusignEnvelope = gql`
  mutation($masterType: HistoryMasterType!, $masterId: Int!, $input: NewDocusignEnvelopeInput!) {
    newDocusignEnvelope(
      masterType: $masterType,
      input: $input,
      masterId: $masterId
    ){
      id
    }
  }
`

// """删除 Docusign Envelope"""
export const deleteDocusignEnvelope = gql`
  mutation($envelopeId: Int!) {
    deleteDocusignEnvelope(
      envelopeId: $envelopeId
    )
  }
`

// """发送 Docusign Envelope"""
export const sendDocusignEnvelope = gql`
  mutation($envelopeId: Int!) {
    sendDocusignEnvelope(
      envelopeId: $envelopeId
    )
  }
`

// """编辑 Docusign Envelope"""
export const editDocusignEnvelope = gql`
  mutation($envelopeId: Int!, $input: EditDocusignEnvelopeInput!) {
    editDocusignEnvelope(
      envelopeId: $envelopeId,
      input: $input
    ){
      id
      clientName
      clientEmail
      subject
      vergeStaff {
        id
        username
      }
      message
      signers {
        signAnchors
        dateSignAnchors
        routingOrder
        recipient {
          name
          email
        }
        signStatus
      }
      status
      sentDate
      completedDate
      documents {
        id
        name
        type
      }
      createdAt
      updatedAt
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`
// """查询 acordForm 模板"""
export const getAcordFormTemplates = gql`
  query($type: String, $query: String) {
    getAcordFormTemplates(
      type: $type,
      query:$query
    )
      {
        id
        templateFileName    
        notes
        usedTimes
        masterType
        createdAt
        updatedAt
      }
  }
`

// """Docusign Template 列表"""
export const getDocusignTemplates = gql`
  query($paging: PagingQuery,$filter: DocusignTemplatesFilter!) {
    getDocusignTemplates(
      paging: $paging,
      filter: $filter
    ) {
      templates {
        id
        name
        fileUrl
        signers {
          signAnchors
          dateSignAnchors
          routingOrder
        }
        params
        createdAt
        updatedAt
        createdBy {
          id,
          username
        }
        lastModifiedBy {
          id,
          username
        }
      }
    }
  }
`

// """根据 id 查询 Docusign Template"""
export const getDocusignTemplate = gql`
  query($templateId: Int!) {
    getDocusignTemplate(
      templateId: $templateId
    ) {
        id
        name
        fileUrl
        signers {
          signAnchors
          dateSignAnchors
          routingOrder
        }
        params
        createdAt
        updatedAt
    }
  }
`

export const getAccountWithContact = gql`
  query($accountId: Int!) {
    getAccount(
      accountId: $accountId
    ) {
      id
      name
      contacts {
        id
        email
        otherEmail
      }
    }
  }
`

// """重新发送 Docusign Envelope"""
export const resendDocusignEnvelope = gql`
  mutation($envelopeId: Int!) {
    resendDocusignEnvelope(
      envelopeId: $envelopeId
    )
  }
`

// """作废 Docusign Envelope"""
export const voidDocusignEnvelope = gql`
  mutation($envelopeId: Int!, $voidedReason: String!) {
    voidDocusignEnvelope(
      envelopeId: $envelopeId
      voidedReason: $voidedReason
    )
  }
`
